import { OldFooter, Footer } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import React from 'react';
import {
  getAppsSection,
  getBottomFooterBar,
  getLinksSection,
  getSocialSection,
} from '../../store/navigation/doubleHeader/footer-old/footer.selectors';
import { getFooter } from '../../store/navigation/default/footer/footer.selectors';

export const OldFooterConnected: React.FunctionComponent = () => {
  const linksSection = useSelector(getLinksSection);
  const oldSocialSection = useSelector(getSocialSection);
  const appsSection = useSelector(getAppsSection);
  const bottomFooterBar = useSelector(getBottomFooterBar);
  return <OldFooter {...{ linksSection, oldSocialSection, appsSection, bottomFooterBar }} />;
};

export const FooterConnected: React.FunctionComponent = () => {
  const footer = useSelector(getFooter);
  return <Footer {...footer} />;
};
